import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { LinkButton } from "@/components/LinkButton";
import { Icon, StyledIconWrapper } from "@/components/Icon";

import { IExtractImagesFromXDHowItWorksItem } from "./types";

type IProps = IExtractImagesFromXDHowItWorksItem;

export const Item: React.FC<IProps> = ({
  title,
  description,
  image,
  icon,
  iconColor,
  rightSidedImage = false,
  button,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <>
      <div
        className={css({
          position: "relative",
          [bp.FROM_TABLET]: {
            gridColumn: rightSidedImage ? "2 / -1" : "1 / 2",
          },
        })}
      >
        <div
          className={css({
            position: "absolute",
            backgroundImage:
              'url("/images/extract-images-from-xd-item-bg.svg")',
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            top: -174,
            left: -174,
            right: -174,
            bottom: -174,
          })}
        />
        <Image
          wrapperStyle={{
            width: "100%",
            borderRadius: 8,
            overflow: "hidden",
            position: "relative",
          }}
          customStyle={{ width: "100%" }}
          {...image}
        />
      </div>

      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          [bp.FROM_TABLET]: {
            gridColumn: rightSidedImage ? "1 / 2" : "2 / -1",
          },
        })}
      >
        <div
          className={css({
            [bp.FROM_TABLET]: {
              maxWidth: 480,
            },
          })}
        >
          <StyledIconWrapper
            width={24}
            height={24}
            wrapperStyle={{
              width: "56px",
              height: "56px",
              borderRadius: "28px",
              backgroundColor: `#FFFFFF`,
              border: `1px solid #E5E7EB`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            customStyle={{
              color: iconColor,
            }}
          >
            <Icon iconType={icon} />
          </StyledIconWrapper>

          <Heading
            as="h3"
            customStyle={{
              fontSize: 28,
              lineHeight: "32px",
              color: colors.DARK_GREY,
              fontWeight: 700,
              marginTop: 24,
              marginBottom: 24,
              [bp.FROM_DESKTOP]: {
                fontSize: 36,
                lineHeight: "46px",
              },
            }}
          >
            {title}
          </Heading>

          <p
            className={css({
              fontSize: 14,
              lineHeight: "22px",
              color: colors.DARK_GREY,
            })}
          >
            {description}
          </p>

          {button && (
            <div className={css({ display: "flex", flexDirection: "row" })}>
              <LinkButton
                href={button.href}
                customStyle={{
                  padding: "10px 24px",
                  backgroundColor: colors.ORANGE,
                  color: colors.WHITE,
                  marginTop: 24,
                  marginBottom: 0,
                  width: "auto",
                }}
                title={button.label}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
